// Absolute URL for the embedded Bihar Krishi AI chat webview.
//
// Defaults to the current origin (+ window.contextPath) so the iframe loads the
// chat route served alongside this app. Override the host via
// REACT_APP_BASE_URL when the chat experience is deployed on a different
// domain (e.g. a standalone chatbot service).
const CHAT_BASE_URL = process.env.REACT_APP_BASE_URL || "";

// For a signed-in user, resolve their display name (falling back to the login
// username) from the persisted user-info so the chat webview can personalise the
// session. Returns "" for a guest / when nothing is stored, so no param is added.
const loggedInUsername = () => {
  if (typeof window === "undefined") return "";
  try {
    if (localStorage.getItem("DfsWeb.isLoggedIn") !== "true") return "";
    const userInfo = JSON.parse(
      localStorage.getItem("DfsWeb.user-info") || "null"
    );
    return userInfo?.name || userInfo?.userName || "";
  } catch {
    return "";
  }
};

export const chatUrl = () => {
  const origin =
    CHAT_BASE_URL ||
    (typeof window !== "undefined" ? window.location.origin : "");
  const base = origin.replace(/\/$/, "");
  const cp =
    (typeof window !== "undefined" && window.contextPath) || "";
  const url = `${base}${cp}/bihar-krishi/chat`;
  // Append `username` only when a logged-in user's name is available (guests get
  // the bare chat URL). Encoded so names with spaces/unicode stay URL-safe.
  const username = loggedInUsername();
  return username ? `${url}?username=${encodeURIComponent(username)}` : url;
};
